/**
 * @generated SignedSource<<ae87a14d96970ebdd3d09f03e5c7746d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarketingEmailDetailsViewMailingListsQuery$variables = Record<PropertyKey, never>;
export type MarketingEmailDetailsViewMailingListsQuery$data = {
  readonly mailingLists: ReadonlyArray<{
    readonly id: string;
    readonly mailingListIdentifier: string;
    readonly name: string;
    readonly subscribedCount: number;
  }>;
};
export type MarketingEmailDetailsViewMailingListsQuery = {
  response: MarketingEmailDetailsViewMailingListsQuery$data;
  variables: MarketingEmailDetailsViewMailingListsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "mailingLists",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mailingListIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subscribedCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailDetailsViewMailingListsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MarketingEmailDetailsViewMailingListsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2fc75e8ea6a865ab70ef309e1cc812c3",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailDetailsViewMailingListsQuery",
    "operationKind": "query",
    "text": "query MarketingEmailDetailsViewMailingListsQuery {\n  mailingLists {\n    id\n    mailingListIdentifier\n    name\n    subscribedCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "224a7f36b336e7b72949bff935dc2b44";

export default node;
